import SkeletonProfile from 'components/ui/Skeleton/Profile';
import { useProfileSizeDetect } from 'hooks/useProfileSizeDetect';
import React, { useRef } from 'react';

const TruckerProfileSkeleton = () => {
  const wrapperRef = useRef(null);
  useProfileSizeDetect(wrapperRef);

  return (
    <div ref={wrapperRef}>
      <SkeletonProfile />
    </div>
  );
};

export default TruckerProfileSkeleton;
